import BatteryChargingFullOutlinedIcon from '@mui/icons-material/BatteryChargingFullOutlined'
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined'
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined'
import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined'
import RouterOutlinedIcon from '@mui/icons-material/RouterOutlined'
import TireRepairIcon from '@mui/icons-material/TireRepair'
import WindowOutlinedIcon from '@mui/icons-material/WindowOutlined'
import { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import EnumIconSelectInput, { EnumField } from '../../components/EnumIconSelectInput'
import {
  INCIDENT_REPORT_CATEGORY_BODYWORK,
  INCIDENT_REPORT_CATEGORY_CONNECTED_DEVICE,
  INCIDENT_REPORT_CATEGORY_12V_BATTERY,
  INCIDENT_REPORT_CATEGORY_LOCKING_SYSTEM,
  INCIDENT_REPORT_CATEGORY_MECHANICAL,
  INCIDENT_REPORT_CATEGORY_NFC_READER,
  INCIDENT_REPORT_CATEGORY_TIRE,
  INCIDENT_REPORT_CATEGORY_WINDSHIELD,
  getIncidentReportCategoryGroupedChoices,
} from '../../config/damages'

export const INCIDENT_CATEGORY_ICONS = {
  [INCIDENT_REPORT_CATEGORY_NFC_READER]: CreditCardOutlinedIcon,
  [INCIDENT_REPORT_CATEGORY_LOCKING_SYSTEM]: LockOutlinedIcon,
  [INCIDENT_REPORT_CATEGORY_CONNECTED_DEVICE]: RouterOutlinedIcon,
  [INCIDENT_REPORT_CATEGORY_BODYWORK]: DirectionsCarOutlinedIcon,
  [INCIDENT_REPORT_CATEGORY_TIRE]: TireRepairIcon,
  [INCIDENT_REPORT_CATEGORY_WINDSHIELD]: WindowOutlinedIcon,
  [INCIDENT_REPORT_CATEGORY_MECHANICAL]: BuildOutlinedIcon,
  [INCIDENT_REPORT_CATEGORY_12V_BATTERY]: BatteryChargingFullOutlinedIcon,
}

export const getIncidentCategoryIcon = (categoryId) =>
  INCIDENT_CATEGORY_ICONS[categoryId] || RadioButtonUncheckedOutlinedIcon

export const getIncidentReportCategoryChoices = ({ nfcAccessSupported, includeBackendManaged } = {}) =>
  getIncidentReportCategoryGroupedChoices({ nfcAccessSupported, includeBackendManaged }).map((choice) =>
    choice.disabled
      ? choice
      : {
          ...choice,
          icon: getIncidentCategoryIcon(choice.id),
        },
  )

const INCIDENT_REPORT_CATEGORY_DISPLAY_CHOICES = getIncidentReportCategoryChoices({
  nfcAccessSupported: true,
  includeBackendManaged: true,
})

export const IncidentCategoryField = (props) => (
  <EnumField
    resource="incident-reports"
    source="category"
    choices={INCIDENT_REPORT_CATEGORY_DISPLAY_CHOICES}
    {...props}
  />
)

const IncidentCategorySelectInput = ({
  source = 'category',
  nfcAccessSupported = false,
  includeBackendManaged = true,
  ...props
}) => {
  const { setValue } = useFormContext()
  const selectedCategory = useWatch({ name: source })

  useEffect(() => {
    if (selectedCategory !== INCIDENT_REPORT_CATEGORY_NFC_READER) return
    if (!nfcAccessSupported) {
      setValue(source, '')
    }
  }, [nfcAccessSupported, selectedCategory, setValue, source])

  return (
    <EnumIconSelectInput
      source={source}
      choices={getIncidentReportCategoryChoices({ nfcAccessSupported, includeBackendManaged })}
      {...props}
    />
  )
}

export default IncidentCategorySelectInput
